import { API_ENDPOINT } from "@/utils/misc";
import axios from "axios";

export const checkIfPublished = (payload) => {
  return axios.get(`${API_ENDPOINT()}/published-schedules/check-if-published`, {
    params: payload,
  });
};
